module.exports = __webpack_public_path__ + "static/media/image-4.10ad7720.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/ConsumerBehaviour/image-4.png
// module id = 447
// module chunks = 0